<template>
  <el-popover
    trigger="focus"
    placement="top"
    :disabled="!hasTips"
    >
    <span
      style="display: block"
      v-for="(tip, tipIndex) in tips"
      v-html="tip"
      :key="tipIndex"></span>
    <el-input-number
      slot="reference"
      v-bind="props"
      :value="value"
      :controls="false"
      @change="onInput"></el-input-number>
  </el-popover>
</template>

<script>
export default {
  props: ["props", "value"],
  computed: {
    key() {
      return this.props.name
    },
    tips() {
      return this.props.tipRule || []
    },
    hasTips() {
      return this.tips.length
    }
  },
  methods: {
    onInput(v) {
      this.$emit('change', v)
    },
  },
}
</script>

<style></style>